export const types = {
    FETCH_ADMIN_SUBSCRIPTIONS_BY_KIND: 'adminSubscriptions/FETCH_BY_KIND',
    FETCH_ADMIN_SUBSCRIPTIONS_BY_KIND_SUCCESS: 'adminSubscriptions/FETCH_BY_KIND_SUCCESS',
    FETCH_ADMIN_SUBSCRIPTIONS_BY_KIND_FAIL: 'adminSubscriptions/FETCH_BY_KIND_FAIL',

    EXPIRE_ADMIN_CREATOR_TRIAL: 'adminSubscriptions/EXPIRE_CREATOR_TRIAL',
    EXPIRE_ADMIN_CREATOR_TRIAL_SUCCESS: 'adminSubscriptions/EXPIRE_CREATOR_TRIAL_SUCCESS',
    EXPIRE_ADMIN_CREATOR_TRIAL_FAIL: 'adminSubscriptions/EXPIRE_CREATOR_TRIAL_FAIL',

    CANCEL_ADMIN_CREATOR_SUBSCRIPTION: 'adminSubscriptions/CANCEL_CREATOR',
    CANCEL_ADMIN_CREATOR_SUBSCRIPTION_SUCCESS: 'adminSubscriptions/CANCEL_CREATOR_SUCCESS',
    CANCEL_ADMIN_CREATOR_SUBSCRIPTION_FAIL: 'adminSubscriptions/CANCEL_CREATOR_FAIL',

    CANCEL_ADMIN_CAMPAIGN_HOST_SUBSCRIPTION: 'adminSubscriptions/CANCEL_CAMPAIGN_HOST',
    CANCEL_ADMIN_CAMPAIGN_HOST_SUBSCRIPTION_SUCCESS: 'adminSubscriptions/CANCEL_CAMPAIGN_HOST_SUCCESS',
    CANCEL_ADMIN_CAMPAIGN_HOST_SUBSCRIPTION_FAIL: 'adminSubscriptions/CANCEL_CAMPAIGN_HOST_FAIL',

    RESET_ADMIN_CREATOR_TRIAL: 'adminSubscriptions/RESET_CREATOR_TRIAL',
    RESET_ADMIN_CREATOR_TRIAL_SUCCESS: 'adminSubscriptions/RESET_CREATOR_TRIAL_SUCCESS',
    RESET_ADMIN_CREATOR_TRIAL_FAIL: 'adminSubscriptions/RESET_CREATOR_TRIAL_FAIL',

    FETCH_ADMIN_PAYSTACK_SWITCH_PLANS: 'adminSubscriptions/FETCH_PAYSTACK_SWITCH_PLANS',
    FETCH_ADMIN_PAYSTACK_SWITCH_PLANS_SUCCESS: 'adminSubscriptions/FETCH_PAYSTACK_SWITCH_PLANS_SUCCESS',
    FETCH_ADMIN_PAYSTACK_SWITCH_PLANS_FAIL: 'adminSubscriptions/FETCH_PAYSTACK_SWITCH_PLANS_FAIL',

    SWITCH_ADMIN_CREATOR_PAYSTACK_PLAN: 'adminSubscriptions/SWITCH_PAYSTACK_PLAN',
    SWITCH_ADMIN_CREATOR_PAYSTACK_PLAN_SUCCESS: 'adminSubscriptions/SWITCH_PAYSTACK_PLAN_SUCCESS',
    SWITCH_ADMIN_CREATOR_PAYSTACK_PLAN_FAIL: 'adminSubscriptions/SWITCH_PAYSTACK_PLAN_FAIL',

    CHARGE_ADMIN_CREATOR_PAYSTACK_AUTHORIZATION: 'adminSubscriptions/CHARGE_PAYSTACK_AUTH',
    CHARGE_ADMIN_CREATOR_PAYSTACK_AUTHORIZATION_SUCCESS: 'adminSubscriptions/CHARGE_PAYSTACK_AUTH_SUCCESS',
    CHARGE_ADMIN_CREATOR_PAYSTACK_AUTHORIZATION_FAIL: 'adminSubscriptions/CHARGE_PAYSTACK_AUTH_FAIL',

    FETCH_FLUTTERWAVE_SYNC_CATALOG: 'adminSubscriptions/FETCH_FLUTTERWAVE_CATALOG',
    FETCH_FLUTTERWAVE_SYNC_CATALOG_SUCCESS: 'adminSubscriptions/FETCH_FLUTTERWAVE_CATALOG_SUCCESS',
    FETCH_FLUTTERWAVE_SYNC_CATALOG_FAIL: 'adminSubscriptions/FETCH_FLUTTERWAVE_CATALOG_FAIL',

    SYNC_FLUTTERWAVE_PLANS_ADMIN: 'adminSubscriptions/SYNC_FLUTTERWAVE_PLANS',
    SYNC_FLUTTERWAVE_PLANS_ADMIN_SUCCESS: 'adminSubscriptions/SYNC_FLUTTERWAVE_PLANS_SUCCESS',
    SYNC_FLUTTERWAVE_PLANS_ADMIN_FAIL: 'adminSubscriptions/SYNC_FLUTTERWAVE_PLANS_FAIL',
};
